import { render, staticRenderFns } from "./DetalhamentoProposta.vue?vue&type=template&id=0d26df90"
import script from "./DetalhamentoProposta.vue?vue&type=script&lang=js"
export * from "./DetalhamentoProposta.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoProposta.vue?vue&type=style&index=0&id=0d26df90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports